import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Tooltip } from 'reactstrap';
import TextInput from 'web/components/form-elements/TextInput';
import TextArea from 'web/components/form-elements/TextArea';
import Select from "web/components/form-elements/Select";
import AlertModal from 'web/components/AlertModal';

import information from "web/assets/images/informationIcon.png";
import SendInvitationIcon from 'web/assets/svg/SendInvitationIcon'
import CloseIconBlackBg from 'web/assets/svg/CloseIconBlackBg'
import { addNetworkEmailAddress } from 'redux/actions/myNetwork';
import MultipleEmailInput from 'web/components/form-elements/MultipleEmailInput';

import { BoxContainer, BoxContainerHeader, ActionBtn, SelectWrapper } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";
import { InviteBodyWrapper } from "web/pages/private/CommonPages/MyNetworks/InviteMember/InviteMemberStyled";

const InviteMember = ({ networkResponse, groupNameState, memberToInviteState, closeIconCallBack, pageLanguageContents, clearmemberToInviteState }) => {
  const dispatch = useDispatch();
  const [alertTypeState, setAlertTypeState] = useState();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const INITIAL_VALUES = {
    userName: memberToInviteState?.userName ? memberToInviteState.userName : '',
    email: memberToInviteState?.email ? memberToInviteState.email : '',
    comment: '',
    selectGroup: groupNameState?.networkName ? groupNameState.networkName : ''
  };
  const VALIDATION_SCHEMA = Yup.object().shape({
    email: Yup.string().trim()
      .email()
      .required(pageLanguageContents?.Validations[4]?.EmailReq)
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,"Please enter a valid email."),
  });
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const sendInviteApi = async (props) => {
    let emailGet = memberToInviteState && memberToInviteState?.email ? [memberToInviteState.email] : props.values.email
    if (!emailGet) {
      setModalContent("Please enter a valid email ID.");
      setModalLink('');
      toggleModal();
    } else {
      if ((groupNameState?.id || groupNameState?.userId) || props.values.selectGroup) {
        let networkIdValue
        if (!groupNameState) {
          networkIdValue = props.values.selectGroup
        } else {
          if (groupNameState.networkId) {
            networkIdValue = groupNameState.networkId
          } else if ((groupNameState?.id || groupNameState?.userId) && !groupNameState.networkId) {
            if (props.values.email && (groupNameState?.id || groupNameState?.userId)) {
              if (groupNameState.networkName) {
                networkIdValue = (groupNameState?.id || groupNameState?.userId)
              } else {
                networkIdValue = props.values.selectGroup
              }
            } else {
              networkIdValue = (groupNameState?.id || groupNameState?.userId)
            }
          }
        }

        let data = {
          emails: memberToInviteState?.email ? [memberToInviteState.email] : props.values.email,
          networkId: networkIdValue,
          comment: props.values.comment
        }
        let inviteResponse = await dispatch(addNetworkEmailAddress(data, token));
        if (inviteResponse.status === "SUCCESS") {
          clearmemberToInviteState()
          setAlertTypeState("createGroup")
          setModalContent(inviteResponse.message);
          setModalLink('');
          toggleModal();
        } else {
          if (inviteResponse.statusCode === 401) {
            history.push('/sign-in')
            window.location.reload(false);
          } else {
            setModalContent(inviteResponse.message);
            setModalLink('');
            toggleModal();
          }
        }
      } else {
        if (!props.values.selectGroup && !groupNameState) {
          let data = {
            emails: memberToInviteState?.email ? [memberToInviteState.email] : props.values.email,
            networkId: "",
            comment: props.values.comment
          }
          let inviteResponse = await dispatch(addNetworkEmailAddress(data, token));
          if (inviteResponse.status === "SUCCESS") {
            clearmemberToInviteState()
            setAlertTypeState("createGroup")
            setModalContent(inviteResponse.message);
            setModalLink('');
            toggleModal();
          } else {
            if (inviteResponse.statusCode === 401) {
              history.push('/sign-in')
              window.location.reload(false);
            } else {
              setModalContent(inviteResponse.message);
              setModalLink('');
              toggleModal();
            }
          }

        }
        else {
          setModalContent("Please select group.");
          setModalLink('');
          toggleModal();
        }

      }

    }

  }

  const [tooltip, setTooltip] = useState(false);
  const [tooltipSection, setTooltipSection] = useState('');
  const iIcon = (infoSection, infoTxt) => {
    return <>
      <img
        id={infoSection}
        src={information}
        style={{ position: "relative", top: "2px", left: '-5px' }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltip && tooltipSection === infoSection}
        target={infoSection}
        toggle={() => {
          setTooltip(!tooltip)
          setTooltipSection(tooltipSection === '' ? infoSection : '')
        }
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  return (<>
    <BoxContainer>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => {
        }}>
        {(props) => {
          const {
            isValid,
            dirty,
            values,
            errors,
            touched,
            setFieldValue,
          } = props;
          return (
            <>
              <Form>
                <BoxContainerHeader>
                  <SelectWrapper>
                    <h2>{pageLanguageContents?.InviteMember[0]?.InviteMember} <span>(Add emails below to invite users to join PalletTrader, or to join your PalletTrader group.)</span></h2>
                    {/* {iIcon('inviteMember', 'Invite new member to join PalletTrader and registered user to join your group.')} */}
                  </SelectWrapper>
                  <CloseIconBlackBg
                    onClick={() => {
                      closeIconCallBack();
                    }}
                  />
                </BoxContainerHeader>
                <InviteBodyWrapper>
                  <div>
                    {memberToInviteState?.email ? <TextInput
                      name="userName"
                      placeholder='Recipient Emails'
                      showErrorMessages={true}
                      disabled={true}
                    /> :
                      <MultipleEmailInput
                        name="email"
                        placeholder='Recipient Emails'
                      />
                    }
                    <div className='invite-select width-class'>
                      {groupNameState && groupNameState.networkName ? <TextInput
                        name="selectGroup"
                        disabled={true}
                        showErrorMessages={true}
                      /> :
                        <div style={{ marginBottom: '20px' }}>
                          <Select
                            name="selectGroup"
                            data={networkResponse}
                            placeholder={pageLanguageContents?.InviteMember[1]?.SelectGroup}
                            onChangeHandler={(data) => { }}
                          />
                        </div>}
                    </div>
                    <TextArea
                      name="comment"
                      inputType="textAndNumber"
                      placeholder={pageLanguageContents?.InviteMember[3]?.AddMessage}
                    />
                  </div>
                </InviteBodyWrapper>
                <ActionBtn>
                  <button
                    onClick={() => {
                      closeIconCallBack();
                    }}
                  >
                    {pageLanguageContents?.InviteMember[4]?.Back}
                  </button>
                  <button onClick={() => {
                    sendInviteApi(props)
                  }}>
                    {pageLanguageContents?.InviteMember[5]?.SendInvite} <SendInvitationIcon />
                  </button>
                </ActionBtn>
              </Form>
            </>
          );
        }}
      </Formik>
    </BoxContainer>
    <AlertModal
      isOpen={modal}
      toggle={toggleModal}
      title={title}
      content={modalContent}
      link={modalLink}
      alertType={alertTypeState}
      callBackAlert={(val) => {
        if (val === "createGroup")
          closeIconCallBack()
      }}
    />
  </>
  );
}



export default InviteMember;
